import { Component, inject } from '@angular/core';
import { routes } from '../app.routes';
import { ThemeService } from '../../core/services/theme.service';
import { RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../core/services/api-endpoints.service';
import { TagComponent } from '../../core/shared/components/tag.component';
import { environment } from '../../environments/environment';
import { ConfirmModalDirective } from '../../core/shared/directives/confirmation-modal.directive';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, RouterLink, TagComponent, ConfirmModalDirective],
  templateUrl: './main.component.html',
  styleUrl: './main.component.css'
})
export class MainComponent {
  themeService = inject(ThemeService);
  authService = inject(AuthService);

  _routes = routes[1].children;

  AppVer = environment.version;

}
